import "../../assets/css/Sidebar/Sidebar.css";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faComputer,
  faClipboard,
  faClock,
  faCertificate,
  faBookOpen,
  faGaugeHigh,
  faCommentDots,
} from "@fortawesome/free-solid-svg-icons";

function Sidebar({ isOpen, closeSidebar }) {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: faGaugeHigh,
    },
    {
      name: "Assessment",
      path: "/assessment",
      icon: faClipboard,
    },
    {
      name: "Certificate",
      path: "/certificate",
      icon: faCertificate,
    },
    {
      name: "My Learning Hub",
      path: "/learning-hub",
      icon: faBookOpen,
    },
    {
      name: "Feedback",
      path: "/feedback",
      icon: faCommentDots,
    },
  ];

  return (
    <aside className={`sidebar ${isOpen ? "open" : ""}`}>
      <ul className="sidebar-options">
        {menuItems.map((item) => (
          <li
            key={item.name}
            className={location.pathname === item.path ? "active" : ""}
            onClick={() => {
              navigate(item.path);
              closeSidebar();
            }}
          >
            <FontAwesomeIcon icon={item.icon} className="menu-icon" />
            <span className="menu-text">{item.name}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default Sidebar;